<template>
  <section>
    <gs-header title="Thêm mới phiếu thu"
      :breadcrumbs="[
        {title: 'Quản lý phiếu thu', route: {name: 'receipt'}}
      ]"
    >
    </gs-header>
    <div class="padding-sm-all">
      <el-form label-position="top" :rules="rules" ref="create-receipt-form" :model="localReceipt" label-width="150px" @submit.prevent.native="validatorBeforeSubmit">
        <el-row :gutter="20" class="remove-margin">
          <el-col :span="8">
            <el-form-item label="Tổng tiền" prop="total_amount">
              <el-input @focus="removeZero('total_amount')" @blur="addZero('total_amount')" v-model="localReceipt.total_amount" placeholder="Tổng tiền">
                <template slot="append"><span class="text-red">{{localReceipt.total_amount | vnd}}</span></template>
              </el-input>
            </el-form-item>
            <el-form-item label="Tìm kiếm khách hàng" prop="client_id">
              <el-select class="display-block"
                v-model="suggettionReceiver"
                filterable
                remote
                placeholder="Nhập tên, sđt..."
                :remote-method="selectReceiver"
                :loading="fetchReceiver"
                @change="selectSuggettionReceiver"
                >
                <el-option
                  v-for="item in listReceiver"
                  :key="item.id"
                  :value="item">
                  <span class="pull-left text-gray"><i class="fa fa-user"></i>&nbsp;{{ item.name }}</span>
                  <span class="pull-right text-violet"><i class="fa fa-phone"></i>&nbsp;{{ item.phone }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Tìm kiếm vận đơn">
              <el-select class="display-block"
                v-model="suggettionShipment"
                filterable
                remote
                placeholder="Nhập mã,..."
                :remote-method="selectShipment"
                :loading="fetchShipment"
                @change="selectSuggettionShipment"
                >
                <el-option
                  v-for="item in listShipment"
                  :key="item.id"
                  :value="item">
                  <span class="pull-left shipment-code-display">{{ item.id }}</span>
                  <span class="pull-right shipment-code-display">{{ item.code }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Lý do" prop="description">
              <el-input type="textarea" :rows="4" v-model="localReceipt.description" placeholder="Lý do"></el-input>
            </el-form-item>
            <button :disabled="submitting" class="ui blue basic small button" native-type="submit"><i class="fa fa-floppy-o"></i> Lưu lại</button>
          </el-col>
          <el-col :span="16">
            <h3 v-if="Object.keys(suggettionReceiver).length">Thông tin khách hàng</h3>
            <p v-if="Object.keys(suggettionReceiver).length"><i class="fa fa-user"></i> {{suggettionReceiver.name}} &nbsp;&nbsp; <i class="fa fa-phone"></i> {{suggettionReceiver.phone}} &nbsp;&nbsp; <i class="fa fa-envelope-o"></i> {{suggettionReceiver.email}}</p>
            <el-table
              v-if="shipmentAdded.length"
              border
              :data="shipmentAdded"
              style="width: 100%">
              <el-table-column
                label="Mã"
                width="120">
                <template slot-scope="scope">
                  <p>
                    <el-tooltip placement="top" content="Mã đơn" class="display-inline">
                      <span class="shipment-code-display">{{ scope.row.id }}</span>
                    </el-tooltip>
                  </p>
                  <p>
                    <el-tooltip placement="top" content="Mã đơn HVC" class="display-inline">
                      <span class="shipment-code-display">{{ scope.row.code }}</span>
                    </el-tooltip>
                  </p>
                </template>
              </el-table-column>

              <el-table-column
                label="Người nhận">
                <template slot-scope="scope">
                  <p><i class="fa fa-user"></i>&nbsp;{{ scope.row.receiver.data.name }}</p>
                  <p><i class="fa fa-phone"></i>&nbsp;{{scope.row.receiver.data.phone}}</p>
                </template>
              </el-table-column>

              <el-table-column
                label="Người gửi">
                <template slot-scope="scope">
                  <p><i class="fa fa-user"></i>&nbsp;{{ scope.row.picker.data.name }}</p>
                  <p><i class="fa fa-phone"></i>&nbsp;{{scope.row.picker.data.phone}}</p>
                </template>
              </el-table-column>

              <el-table-column
                label="Phí COD">
                <template slot-scope="scope">
                  <span class="text-red">{{ scope.row.id | vnd}}</span>
                </template>
              </el-table-column>

              <el-table-column
                label="Người trả phí"
                width="110">
                <template slot-scope="scope">
                  <span >{{ scope.row.payer_txt }}</span>
                </template>
              </el-table-column>

              <el-table-column
                label=""
                width="50"
                >
                <template slot-scope="scope">
                  <el-tooltip placement="top" content="Xóa" class="display-inline">
                    <a class="text-red padding-all display-inline-block cursor-pointer" @click.prevent="removeShipment(scope.row)"><i class="fa fa-trash"></i></a>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </section>
</template>
<script type="text/javascript">
  import receiptMixin from './mixins'
  import { createReceipt } from 'src/api/receipt'
  import { head } from 'lodash'
  export default {
    name: 'CreateReceipt',
    mixins: [receiptMixin],
    methods: {
      validatorBeforeSubmit () {
        this.submitting = true
        this.$refs['create-receipt-form'].validate((valid) => {
          if (valid) {
            this.changedData = false
            createReceipt(this.localReceipt).then(response => {
              switch (response.code) {
                case 200:
                  this.$store.dispatch('showNotify', {
                    title: 'Thêm mới thành công',
                    body: 'Thêm mới phiếu thu thành công',
                    type: 'success'
                  })
                  this.reloadGsTableAfterRedirect({name: 'receipt'}, 'receipts')
                  this.submitting = false
                  break
                case 422:
                  let er = response.data.errors
                  let message = head(er[Object.keys(er)[0]])
                  this.$store.dispatch('showNotify', {
                    title: 'Vui lòng kiểm tra thông tin cần nhập',
                    body: message,
                    type: 'warning'
                  })
                  this.submitting = false
                  break
                default:
                  this.$store.dispatch('showNotify', {
                    title: 'Thêm mới thất bại',
                    body: 'Thêm phiếu thu thất bại vui lòng kiểm tra lại thông tin',
                    type: 'danger'
                  })
                  this.submitting = false
              }
            })
          } else {
            this.$store.dispatch('showNotify', {
              title: 'Vui lòng kiểm tra thông tin cần nhập',
              type: 'warning'
            })
            this.submitting = false
            return false
          }
        })
      },
      newReceipt () {
        this.localReceipt = {
          id: 0,
          shipments: [],
          total_amount: 0,
          description: '',
          client_id: 0
        }
        setTimeout(() => {
          this.watching = true
        }, 100)
      }
    }
  }
</script>
<style type="text/css" scoped>

</style>



// WEBPACK FOOTER //
// NewReceipt.vue?76792506